import { Component } from '@angular/core';

@Component({
    selector: 'tcm-details-layout',
    templateUrl: './tcm-details-layout.component.html',
    styleUrls: ['./tcm-details-layout.component.scss'],
    standalone: false
})
export class TcmDetailsLayoutComponent {
}
